import { FC } from 'react'
import { Container } from './styles'
import { MdOutlineKeyboardArrowRight, MdOutlineKeyboardArrowLeft } from 'react-icons/md'

interface PaginationProps {
  currentPage: number;
  setCurrentPage: (page: number) => void;
  totalPages: number;
}

const Pagination: FC<PaginationProps> = ({
  currentPage,
  setCurrentPage,
  totalPages
}) => {
  const totalPagesArray = Array.from(Array(totalPages).keys()).map(page => page + 1)

  const pages = () => {
    if(totalPages === 2) return [1, 2]
    return currentPage === 1 ?
      totalPagesArray.slice(currentPage - 1, currentPage + 2) :
      currentPage === totalPagesArray.length ? 
      totalPagesArray.slice(currentPage - 3, currentPage) :
      totalPagesArray.slice(currentPage - 2, currentPage + 1)
  }

  const goBack = () => {
    if(currentPage > 1)
      setCurrentPage(currentPage - 1)
  }

  const goForward = () => {
    if(currentPage < totalPages)
      setCurrentPage(currentPage + 1)
  }

  return (
    <Container className='pagination-container'>
      <div className={`${currentPage > 1 ? 'available' : ''}`} onClick={goBack}><MdOutlineKeyboardArrowLeft size={20} /></div>
      {pages().map(page => (
        <div
          key={page}
          className={`${page === currentPage ? 'selected' : ''}`}
          onClick={() => setCurrentPage(page)}
        >
          {page}
        </div>
      ))}
      <div className={`${currentPage < totalPages ? 'available' : ''}`} onClick={goForward}><MdOutlineKeyboardArrowRight size={20} /></div>
    </Container>
  )
}

export default Pagination